<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <foreignObject
      x="-3.61926"
      y="-3.61926"
      width="31.2385"
      height="31.2385"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      style="backdrop-filter:blur(1.81px);clip-path:url(#bgblur_0_1510_15169_clip_path);height:100%;width:100%"
    ></div></foreignObject><circle
      data-figma-bg-blur-radius="3.61926"
      cx="12"
      cy="12"
      r="12"
      fill="#D9D2FF"
    />
    <path
      d="M10.759 17.3622C10.4427 17.3622 10.1432 17.2141 9.9513 16.9587L7.35381 13.5145C7.2735 13.4082 7.21487 13.287 7.18127 13.1578C7.14767 13.0287 7.13976 12.8942 7.15799 12.762C7.17622 12.6298 7.22023 12.5025 7.28751 12.3874C7.35479 12.2723 7.44402 12.1717 7.55009 12.0912C7.65613 12.0104 7.77702 11.9513 7.90582 11.9175C8.03463 11.8836 8.16883 11.8756 8.30073 11.8939C8.43262 11.9122 8.55962 11.9565 8.67445 12.0241C8.78928 12.0918 8.88967 12.1815 8.96988 12.2882L10.679 14.5527L14.9762 7.62778C15.1187 7.39913 15.3458 7.23655 15.6076 7.17569C15.8694 7.11483 16.1445 7.16066 16.3727 7.30313C16.8474 7.59932 16.9935 8.22674 16.6969 8.70387L11.6197 16.8821C11.533 17.0224 11.4136 17.1393 11.2717 17.2227C11.1298 17.3061 10.9698 17.3535 10.8055 17.3607C10.7895 17.3622 10.775 17.3622 10.759 17.3622Z"
      fill="white"
    />
    <defs>
      <clipPath
        id="bgblur_0_1510_15169_clip_path"
        transform="translate(3.61926 3.61926)"
      ><circle
        cx="12"
        cy="12"
        r="12"
      />
      </clipPath></defs>
  </svg>
</template>

<script>
export default {
  name: 'IconCheckCircleFill'
}
</script>